import React, { useContext } from "react";
import CustomizedCheckbox from "src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Checkbox"
import { COLOUR } from "../../constant"
import { SortAndFilterContent } from "../../SortAndFilterContent";
import { getFilterOptionStyle } from "../../utils";
import { isMobileDevice } from "src/components/WidgetMaker/WidgetDnD/isMobileDevice";
import { useWidgetDndContextData } from "src/context/WidgetDndContext";
import { buttonStyle, globalStyleValue } from "src/utils/globalStyleHelper";
import { useSelector } from "src/redux";

function Layout1(props) {
  const { handleCheckboxClick, pageStyle } = useContext(SortAndFilterContent);
  const { filterData, type, filterName } = props;
  const isMobile = isMobileDevice();
  const {
    widgetContextState: { isBuilder,  globalStyle },
  } = useWidgetDndContextData();
  const storeInfo = useSelector((state) => state.storeReducer.store);
  const themeColor = isBuilder ? globalStyle?.color?.themeColor : storeInfo?.theme?.colors?.primary_color


  const boxRadius = buttonStyle(globalStyle, 4, true);
  const borderRadiusVal = globalStyleValue(boxRadius?.borderRadius);

  return (
    <div className="tw-flex tw-items-center tw-gap-[10px]">
      <CustomizedCheckbox
        checked={filterData?.is_selected}
        handleChange={(e) => { handleCheckboxClick?.(e, filterName, filterData?.name) }}
        borderRadius={Number(borderRadiusVal)}
        selectedBackgroundColor={themeColor}
      />
      {type === COLOUR && <div style={{ border: filterData?.is_selected ? `1px solid ${themeColor}` : '' }}
        className="tw-w-[22px] tw-h-[22px] tw-rounded-[50%] tw-flex tw-justify-center tw-items-center">
        <div style={{ background: filterData?.colour_code }} className="tw-w-[16px] tw-h-[16px] tw-rounded-[50%]"></div>
      </div>}
      <div style={{ ...getFilterOptionStyle(pageStyle, isMobile) }} className={`${filterData?.is_selected ? 'tw-font-semibold tw-text-newBlack' : ''}`}>{filterData?.name}</div>
    </div>
  )
}

export default Layout1